import store from "@/store";
import {
  MSG_ALERT,
  MSG_CONFIRM,
  MSG_NOTIFICATION
} from "@/store/actions/actions.type";
import Vue from "vue";

const mappers = {
  types: {
    info: {
      icon: "mdi-information"
    },
    success: {
      icon: "mdi-check-circle"
    },
    warning: {
      icon: "mdi-exclamation"
    },
    error: {
      icon: "mdi-alert"
    }
  }
};

const defaults = {
  alert: {
    show: false,
    dark: true,

    // icone X para fechar
    dismissible: false,

    //info | success | warning | error
    type: "info",

    //Se não quiser passar o tipo e colocar uma cor diferente
    color: "",

    //left | right | top | bottom
    border: "left",

    //ícones mdi
    icon: undefined,

    //quantidade de tempo que fecha se não for dismissible
    timeout: 3000,
    actions: []
  },
  notification: {
    show: false,
    dark: false,

    // icone X para fechar
    dismissible: false,

    //Se não quiser passar o tipo e colocar uma cor diferente
    color: "",

    //left | right | top | bottom
    border: "left",

    //ícones mdi
    icon: undefined,

    iconNotification: undefined,

    //quantidade de tempo que fecha se não for dismissible
    timeout: 10000,
    actions: []
  },
  confirm: {
    show: false,

    //Se o text for html, informar
    hasHtmlContent: false,

    //info | success | warning | error
    type: "info",

    //Se não quiser passar o tipo e colocar uma cor diferente
    color: "",

    //ícones mdi
    icon: "mdi-information",

    //array de obj para montar os botões com:
    //{ text:"", btnColor:"primary | secondary | info | success | warning | error", callback: function }
    actions: [
      {
        text: "OK",
        btnColor: "primary"
      }
    ]
  }
};

const isActionsPropsValid = actions => {
  if (actions.length === 0) {
    return false;
  }

  let isValid = true;

  for (let i = 0; i < actions.length; i++) {
    const element = actions[i];

    if (!element.hasOwnProperty("text") || typeof element.text !== "string") {
      isValid = false;
      break;
    }

    if (
      !element.hasOwnProperty("btnColor") ||
      typeof element.btnColor !== "string"
    ) {
      isValid = false;
      break;
    }

    if (
      element.hasOwnProperty("callback") &&
      typeof element.callback !== "function"
    ) {
      isValid = false;
      break;
    }
  }

  return isValid;
};

const sanitizeOptions = options => {
  options = options || {};

  const availableTypes = ["info", "success", "warning", "error"];

  options.hasHtmlContent = !!options.hasHtmlContent;

  //se passou tipos nao permitidos
  if (!availableTypes.some(val => options.type === val)) {
    options.type = defaults.confirm.type;
  }

  //se color nao for string ou for string vazia
  if (typeof options.color !== "string" || options.color.length === 0) {
    options.color = defaults.confirm.color;
  }

  //se o tipo do icon nao for string, seja por nao ter sido informado ou seja por ter sido qualquer outro tipo de dado informado errado
  if (typeof options.icon !== "string") {
    options.icon = "";
  }

  //se o length do icon for zero, seja por ter caido no if anterior
  //ou seja por ter sido informado vazio proposital
  if (options.icon.length === 0) {
    options.icon = mappers.types[options.type].icon;
  }

  //se actions nao foi informado
  if (
    typeof options.actions === "undefined" ||
    typeof options.actions === "null"
  ) {
    options.actions = [...defaults.confirm.actions];
  }

  //se actions nao for um array ou for um array com props erradas
  //aí TOME! uma exception pq ta o dev querendo zuar demais! hahaha
  if (Array.isArray(options.actions) && !isActionsPropsValid(options.actions)) {
    throw "A propriedade Actions precisa ser um array e conter um objeto com propriedades obrigatórias 'text' do tipo String, 'btnColor' do tipo String e opcional 'callback' do tipo Function";
  }

  return options;
};

const msg = {
  alert: (text, options = null) => {
    return new Promise((resolve, reject) => {
      const mergedOptions = {
        ...defaults.alert,
        ...options
      };

      const params = {
        ...mergedOptions,
        text: text,
        show: true
      };

      Vue.nextTick(() => {
        store
          .dispatch(`application/${MSG_ALERT}`, params)
          .then(() => {
            resolve();
          })
          .catch(e => {
            reject(e);
          });
      });
    });
  },
  notification: (text, options = null) => {
    return new Promise((resolve, reject) => {
      const mergedOptions = {
        ...defaults.notification,
        ...options
      };

      const params = {
        ...mergedOptions,
        text: text,
        show: true
      };

      Vue.nextTick(() => {
        store
          .dispatch(`application/${MSG_NOTIFICATION}`, params)
          .then(() => {
            resolve();
          })
          .catch(e => {
            reject(e);
          });
      });
    });
  },
  confirm: (title, text, options = null) => {
    return new Promise((resolve, reject) => {
      options = sanitizeOptions(options);

      let mergedOptions = {
        ...defaults.confirm,
        ...options
      };

      let params = {
        ...mergedOptions,
        title: title,
        text: text,
        show: true
      };

      Vue.nextTick(() => {
        store
          .dispatch(`application/${MSG_CONFIRM}`, params)
          .then(() => {
            resolve();
          })
          .catch(e => {
            reject(e);
          });
      });
    });
  }
};

export default msg;
